import type { Issue } from '../types/issue';
import { workspaceStages } from './issueProgress';

export type StageRelation = 'past' | 'current' | 'future' | 'offpath';

type StageIssue = Pick<Issue, 'mode' | 'status'>;

export function currentStageKey(issue: StageIssue): string | null {
  return workspaceStages(issue as Issue).find((stage) => stage.statuses.includes(issue.status))?.key ?? null;
}

/** Estado de tela. Null significa seguir a etapa do processo. Não vai para o banco. */
export function resolveSelectedStage(selected: string | null, issue: StageIssue): string | null {
  const stages = workspaceStages(issue as Issue);
  if (selected && stages.some((stage) => stage.key === selected)) return selected;
  return currentStageKey(issue);
}

export function stageRelation(issue: StageIssue, key: string): StageRelation {
  const stages = workspaceStages(issue as Issue);
  const current = stages.findIndex((stage) => stage.statuses.includes(issue.status));
  const index = stages.findIndex((stage) => stage.key === key);
  if (index < 0) return 'offpath';
  if (current < 0) return 'past';
  if (index < current) return 'past';
  if (index === current) return 'current';
  return 'future';
}

export function stageIsReadOnly(relation: StageRelation): boolean {
  return relation === 'future';
}

/** O clique só escolhe a etapa consultada. Não carrega status nem escrita. */
export function inspectStage(key: string): { selectedStage: string } {
  return { selectedStage: key };
}

export function selectedStagePersists(): false {
  return false;
}
